// extracted by mini-css-extract-plugin
module.exports = {"root":"NavLink_root__lja6M","mobile":"NavLink_mobile__MnfEd","blueLink":"NavLink_blueLink__uczih"};